
export default {
  name: 'MButton',
  props: {
    text: {
      type: String,
      require: true
    }
  }
}
